<template>
  <ValidationObserver
    ref="observer"
    v-slot="{passes}"
    tag="form"
    @submit.prevent="onSubmit">
    <BaseTextareaWithProvider
      v-model="detail"
      placeholder="コメントを入力してください。"
      rows="5"
      name="コメント"
      vid="detail" />
    <div
      v-if="attachmentOption"
      class="general-form__group form-group mt-3 mt-md-4">
      <FileUploaderWithProvider
        v-model="file"
        vid="file" />
    </div>
    <BaseButton
      class="mt-3"
      type="submit">
      コメントを追加
    </BaseButton>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider.vue'
import FileUploaderWithProvider from '@/components/parts/FileUploaderWithProvider.vue'
import BaseButton from '@/components/parts/BaseButton.vue'

/**
 * @description コメントのための共通コンポーネント
 */
export default {
  components: {
    BaseButton,
    BaseTextareaWithProvider,
    FileUploaderWithProvider,
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    fieldId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      detail: '',
      file: null
    }
  },
  computed: {
    ...mapGetters('tenant', ['attachmentOption']),
    hasFile() {
      return this.file != null
    }
  },
  methods: {
    async onSubmit() {
      const isValid = this.detail || this.file
      if (!isValid) {
        return
      }
      const formData = new FormData()
      formData.append(this.fieldId, this.id)
      formData.append('detail', this.detail)
      if (this.file) {
        formData.append('file', this.file)
      }
      this.$emit('submit', formData)
      this.detail = ''
      this.file = null
      this.$refs.observer.reset()
    },
  }
}
</script>
<style lang="scss" scoped>
.comment{
  background-color: $grey15;
}
</style>